var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MenuNonBack',{attrs:{"img_header":_vm.img_holder,"header":"รายการใบตรวจสอบเข้าคลัง (Order status control list)"}}),_c('Order_control_list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }